<template>
  <div
    id="modal_showAppLog"
    class="modal fade"
  >
    <div
      id="print-area"
      class="modal-dialog modal-full"
    >
      <div
        class="modal-content"
        style="border-style: dashed; border-width: 1px"
      >
        <div class="modal-header">
          <button
            id="close-button"
            type="button"
            class="close"
            @click="closeModal('modal_showAppLog')"
          >
            &times;
          </button>
        </div>

        <!-- Header: Logo + Company Info -->
        <table id="head-table">
          <tr>
            <td style="width: 130px;" class="print-pl-20">
              <img
                style="width: 110px; height: 100px"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table id="company-info" style="width: 100%;" class="print-ml-0">
                <tr class="header-table">
                  <td style="font-size: 14px; font-weight: bold;" class="print-pr-20">{{ companyData.company_name }}</td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">{{ companyData.company_address }}</td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">{{ companyData.phone_number }}</td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">{{ companyData.company_email }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body">

          <!-- Title -->
          <table style="width: 100%; margin-top: 10px;" id="print-table1">
            <tr>
              <td style="text-align: center; padding: 8px 0;">
                <strong style="font-size: 22px; text-transform: uppercase;">
                  <span v-if="detialData.description === 'Add to Credit'">{{ $t('logs.refundInvoiceTitle') }}</span>
                  <span v-else>{{ $t('logs.shoppingOnlineInvoiceTitle') }}</span>
                </strong>
              </td>
            </tr>
          </table>

          <!-- Invoice Info + Invoiced To -->
          <table style="width: 100%; margin-bottom: 10px; border: 1px solid #000;" id="print-table2">
            <tr>
              <td style="padding: 10px; width: 50%; vertical-align: top; border-right: 1px solid #000;">
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.invoiceNumber') }}:</strong>
                  <span> {{ detialData.invoice_number }}</span>
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('customer.invoiceDate') }}:</strong>
                  <span v-if="detialData.credit_log_transaction_date"> {{ detialData.credit_log_transaction_date }}</span>
                  <span v-else> {{ detialData.created_at }}</span>
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('logs.orderNumberColon') }}</strong>
                  <span> {{ detialData.theOrderID }}</span>
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.description') }}:</strong>
                  <span> {{ detialData.description }}</span>
                </p>
              </td>
              <td style="padding: 10px; width: 50%; vertical-align: top;">
                <p style="font-size: 14px; font-weight: bold; margin: 0 0 6px 0; text-decoration: underline;">{{ $t('delivery.invoicedToLabel') }}</p>
                <p style="font-size: 14px; margin: 3px 0; font-weight: bold; background-color: yellow; color: black; display: inline-block;">
                  {{ detialData.full_name }}
                </p>
                <p v-if="detialData.delivery_confirmed && detialData.delivery_type === 'office delivery'" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('delivery.deliveryMethodLabel') }}</strong>
                  <span style="color: #e65100; font-weight: bold;">{{ $t('delivery.pickupInOfficeLabel') }}</span>
                </p>
                <p v-else-if="detialData.address || detialData.delivery_address_label" style="font-size: 14px; margin: 3px 0;">
                  <strong>{{ $t('columns.deliveryAddress') }}:</strong>
                  {{ (detialData.delivery_type === 'home delivery' && detialData.delivery_address_label) ? detialData.delivery_address_label : detialData.address }}
                </p>
                <p style="font-size: 14px; margin: 3px 0;">
                  {{ $t('logs.phoneColon') }} {{ detialData.phone_number }}
                </p>
                <p v-if="detialData.email" style="font-size: 14px; margin: 3px 0;">
                  {{ $t('logs.emailColon') }} {{ detialData.email }}
                </p>
              </td>
            </tr>
          </table>

          <!-- REFUND INVOICE -->
          <table
            v-if="detialData.description === 'Add to Credit'"
            style="width: 100%; border-collapse: collapse; border: 1px solid #000;"
            id="print-table3"
          >
            <thead>
              <tr style="background-color: #f2f2f2; font-size: 13px;">
                <th style="border: 1px solid #000; padding: 6px;">{{ $t('logs.itemColumn') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.amount') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="font-size: 13px;">
                <td style="border: 1px solid #000; padding: 5px;">
                  {{ $t('logs.refundReasonPrefix') }} {{ detialData.refund_reason }}
                </td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ detialData.money_amount }}</td>
              </tr>
            </tbody>
          </table>

          <!-- REGULAR ORDER INVOICE — Items Table -->
          <table
            v-else
            style="width: 100%; border-collapse: collapse; border: 1px solid #000;"
            id="print-table3"
          >
            <thead>
              <tr style="background-color: #f2f2f2; font-size: 13px;">
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">#</th>
                <th style="border: 1px solid #000; padding: 6px;">{{ $t('columns.productName') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('columns.size') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.price') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: center;">{{ $t('columns.qty') }}</th>
                <th style="border: 1px solid #000; padding: 6px; text-align: right;">{{ $t('columns.total') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr style="font-size: 13px;">
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">1</td>
                <td style="border: 1px solid #000; padding: 5px;">{{ detialData.product_name }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detialData.size }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ orderUnitPriceWithIntShipping(detialData).toFixed(2) }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: center;">{{ detialData.quantity }}</td>
                <td style="border: 1px solid #000; padding: 5px; text-align: right;">$ {{ orderLineTotalWithIntShipping(detialData).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Fees + Totals (single table so all borders align) -->
          <table style="width: 100%; border-collapse: collapse; margin-top: 0; table-layout: fixed;">
            <colgroup>
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <!-- Additional Fees (regular orders only) -->
            <tr v-if="detialData.description !== 'Add to Credit' && Number(detialData.tax) > 0" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('columns.tax') }}:</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">$ {{ detialData.tax }}</td>
            </tr>
            <!-- Int. shipping rolled into Price / line total above (item_price + internal_shipping_handling per unit × qty) -->
            <!--
            <tr v-if="detialData.description !== 'Add to Credit' && detialData.internal_shipping_handling && Number(detialData.internal_shipping_handling) > 0" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">Int. Shipping:</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">$ {{ Number(detialData.internal_shipping_handling).toFixed(2) }}</td>
            </tr>
            -->
            <tr v-if="detialData.description !== 'Add to Credit' && detialData.insurance && Number(detialData.insurance) > 0" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('customer.insurance') }}:</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">$ {{ detialData.insurance }}</td>
            </tr>
            <tr v-if="detialData.description !== 'Add to Credit' && detialData.delivery_price && Number(detialData.delivery_price) > 0" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('logs.deliveryPriceColon') }}</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">$ {{ detialData.delivery_price }}</td>
            </tr>
            <tr v-if="detialData.description !== 'Add to Credit' && detialData.local_delivery && Number(detialData.local_delivery) > 0" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('logs.deliveryColon') }}</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">{{ localDeliveryIqd }} IQD &nbsp;/&nbsp; $ {{ localDeliveryUsd }}</td>
            </tr>
            <tr v-if="detialData.description !== 'Add to Credit' && detialData.kreenex_fee && Number(detialData.kreenex_fee) > 0" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('logs.shipZoneFeeColon') }}</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">$ {{ detialData.kreenex_fee }}</td>
            </tr>
            <!-- Delivery Iraqi Price -->
            <tr v-if="detialData.description !== 'Add to Credit' && detialData.delivery_price && Number(detialData.delivery_price) > 0" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('logs.deliveryIraqiPriceColon') }}</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">{{ deliveryIqd }} IQD &nbsp;/&nbsp; $ {{ Number(detialData.delivery_price).toFixed(2) }}</td>
            </tr>
            <!-- Totals -->
            <tr style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.totalUsdLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;">
                <span style="background-color: yellow; color: black;">$ {{ totalUsd }}</span>
              </td>
            </tr>
            <tr style="font-size: 15px; font-weight: bold;">
              <td style="border: 1px solid #000; padding: 6px 8px;">{{ $t('delivery.iraqiDinarLabel') }}</td>
              <td style="border: 1px solid #000; padding: 6px 8px; text-align: right;">{{ totalIqd }} IQD</td>
            </tr>
            <tr v-if="detialData.paid_amount && detialData.description !== 'Add to Credit'" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('invoice.paidStatus') }}:</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">$ {{ detialData.paid_amount }}</td>
            </tr>
            <tr v-if="detialData.paid_amount && detialData.description !== 'Add to Credit'" style="font-size: 14px;">
              <td style="border: 1px solid #000; padding: 4px 8px; font-weight: bold;">{{ $t('columns.remaining') }}:</td>
              <td style="border: 1px solid #000; padding: 4px 8px; text-align: right;">$ {{ (Number(detialData.amount) - Number(detialData.paid_amount)).toFixed(2) }}</td>
            </tr>
          </table>

          <!-- Signature -->
          <table style="width: 100%; margin-top: 30px;">
            <tr>
              <td style="font-size: 14px; padding-top: 20px;">
                {{ $t('logs.signatureLabel') }}
              </td>
              <td style="text-align: right; font-size: 14px; font-weight: bold; padding-top: 20px;">
                {{ companyData.company_name }}
              </td>
            </tr>
          </table>

          <div style="margin-top: 10px;" class="print-float-right">
            <v-btn
              @click="printInvoice"
              id="print-button"
              style="height: auto"
              outline
              color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn>
          </div>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { roundUpIqd } from '../../mixins/helpers'

export default {
  props: {
    detialData: { default: () => ({}) },
    closeModal: { default: null },
    companyData: { default: () => ({}) },
    exRate: { default: 1 }
  },

  mounted() {
    let theModal = document.querySelector('.modal')
    theModal.style.overflowX = 'auto'
  },

  computed: {
    totalUsd() {
      const val = this.detialData.description === 'Add to Credit'
        ? this.detialData.money_amount
        : this.detialData.amount
      return Number(val || 0).toFixed(2)
    },
    totalIqd() {
      const raw = Number(this.totalUsd) * Number(this.exRate)
      return roundUpIqd(raw).toLocaleString()
    },
    deliveryIqd() {
      const raw = Number(this.detialData.delivery_price || 0) * Number(this.exRate)
      return roundUpIqd(raw).toLocaleString()
    },
    localDeliveryIqd() {
      const raw = Number(this.detialData.local_delivery || 0)
      return roundUpIqd(raw).toLocaleString()
    },
    localDeliveryUsd() {
      const rate = Number(this.exRate) || 1
      const usd = Number(this.detialData.local_delivery || 0) / rate
      return usd.toFixed(2)
    }
  },

  methods: {
    orderUnitPriceWithIntShipping(d) {
      const row = d || {}
      return Number(row.item_price || 0) + Number(row.internal_shipping_handling || 0)
    },
    orderLineTotalWithIntShipping(d) {
      const row = d || {}
      return this.orderUnitPriceWithIntShipping(row) * Number(row.quantity || 1)
    },

    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()

      $('#print-area').printMe({
        path: this.$_print_stylesheet_paths(),
        filename: `SZ_Invoice_${this.detialData.invoice_number}`
      })

      $('#close-button').show()
      $('#print-button').show()
    },
  },
}
</script>
<style>
#print-area {
  max-width: 850px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #table-header {
    width: 500px;
    padding-left: 60px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    margin-left: 0%;
    margin-right: 20px;
    padding: 0px;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logs/viewLogDetails.vue